// extracted by mini-css-extract-plugin
export default {"ingresosPoModule":"ingresosPOStyles_ingresosPoModule__KdEQ0","ant-table-row":"ingresosPOStyles_ant-table-row__-U3-W","lineasActa":"ingresosPOStyles_lineasActa__h3Yag"};